import React, { useState } from "react";
import { Modal } from "@ctsu/react-ctsu-ui";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import { FasHistory } from "assets/icons";
import RequestFormHistory from "./RequestFormHistory";
import StatusHistory from "./StatusHistory";


const RequestHistory = ({
  requestNumber,
  isOpen,
  onClose,
  requestHistory,
  isLoading,
  error,
  statusHistory,
  isLoadingStatusHistory,
  statusError,
  formPartType
}) => {
  const [tabIndex, setTabIndex] = useState(0);

  if (!isOpen) return null;

  return (
    <Modal
      id="request-history-modal"
      modalTitle={(
        <>
          <FasHistory className="mr-1" />
          Request {requestNumber} History
        </>
      )}
      onClose={onClose}
      showCloseBtn
      modalSize="xl"
      modalMaxHeight
    >
      <div className="request-history-content">
        <Tabs className="ctsuTabs-wrapper" forceRenderTabPanel selectedIndex={tabIndex} onSelect={setTabIndex}>
          <TabList className="ctsuTabs-tabs">
            <Tab className="ctsuTabs-tab">Request Form History</Tab>
            <Tab className="ctsuTabs-tab">Status History</Tab>
          </TabList>

          <TabPanel className="ctsuTabs-tabPanel">
            <div className={`ctsuTabs-content ${tabIndex === 0 ? "active" : "d-none"}`}>
              <RequestFormHistory
                requestHistory={requestHistory}
                isLoading={isLoading}
                error={error}
                formPartType={formPartType}
                requestNumber={requestNumber}
              />
            </div>
          </TabPanel>

          <TabPanel className="ctsuTabs-tabPanel">
            <div className={`ctsuTabs-content ${tabIndex === 1 ? "active" : "d-none"}`}>
              <StatusHistory statusHistory={statusHistory} isLoading={isLoadingStatusHistory} error={statusError}  requestNumber={requestNumber}/>
            </div>
          </TabPanel>
        </Tabs>
      </div>
    </Modal>
  );
};

export default RequestHistory;
